import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

import DynamicEventServiceDetailsForm from '../components/event-details/dynamic-event-service-details';
import {
  getEvent,
  getEventSlots,
  getServiceSlot,
  startLoading,
  submitEventBooking,
  submitEventWaitlist,
} from '../state/actions/service';
import '../styles/service-description.scss';

function translateError(error) {
  switch (error) {
    case 'user:_fully_booked':
      return '(It looks like you already have a service booked. If this is not correct, try using a different email address or contact hello@mioo.cc)';
    case 'failed_to_create_booking:_event:_fully_booked':
      return '(This event become in this second fully booked, please sign up to the waiting list ) ';
    case 'event:_not_active':
      return '(This event is no longer active for bookings) ';
    case 'failed_to_create_service:_bikes:_fully_booked':
    case 'failed_to_add_to_waitlist:_bikes:_fully_booked':
      return '( It looks like you have a booking for all your bikes. To proceed, use a different email address or contact hello@mioo.cc)';
    default:
      return error;
  }
}

function DynamicEventDetails() {
  const history = useHistory();
  const dispatch = useDispatch();
  const service = useSelector((state) => state.service);
  const { slug } = useParams();

  const onFormSubmitHandler = (data) => {
    dispatch(startLoading());
    if (data.status_id === 5) {
      dispatch(submitEventWaitlist({ ...data, event_id: parseInt(service.event.id, 10) }, history));
    } else {
      dispatch(submitEventBooking({ ...data, event_id: parseInt(service.event.id, 10) }, history));
    }
  };

  useEffect(() => {
    dispatch(getEvent(slug));
    dispatch(getEventSlots(slug));
  }, [slug, dispatch]);

  const serviceSlotId = service && service.event && service.event.serviceSlotId;

  useEffect(() => {
    if (serviceSlotId) {
      console.log('service.event.service_slot_id	', serviceSlotId);
      dispatch(getServiceSlot(serviceSlotId));
    }
  }, [dispatch, serviceSlotId]);

  if (!service.event && !service.loading && service.error === 'event_does_not_exist') {
    return <Redirect to="/" />;
  }
  const err = service.error || service.slotsError || service.serviceSlotError;

  return (
    <div className="container">
      <ServiceDescription event={service.event} />
      <DynamicEventServiceDetailsForm
        onSubmit={onFormSubmitHandler}
        slots={service.slots}
        isLoading={service.loading}
        errorMessage={err ? translateError(err.event ? err.event.event : err) : null}
        eventStatus={service.event ? service.event.eventStatusId : null}
        serviceSlot={service.serviceSlot}
      />

      <div className="privacy-policy">
        <div>
          I hereby accept MIOO Cycling’s <br />
          <div className="text-center">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://mioo.cc/sv/om-mioo/integritetspolicy"
            >
              Privacy Policy.
            </a>
          </div>
        </div>
      </div>
      {service.event && service.event.logo && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 20,
            paddingBottom: 20,
            flexDirection: 'column',
          }}
        >
          <h5 style={{ fontWeight: 'bold' }}>MIOO</h5>
          <p style={{ fontStyle: 'italic' }}>In collaboration with</p>
          <img className="logo" src={service.event.logo} alt="company-logo" width="100" />
        </div>
      )}
    </div>
  );
}

function ServiceDescription(props) {
  return (
    <div className="service-description">
      <h1>Bike service</h1>
      <div className="break-line" />

      {props.event && (
        <div>
          <h3>{props.event.name}</h3>
          <p>{props.event.eventDescription}</p>
          <p>
            You drop off your bike at your booked time and will be informed on-site when it is
            expected to be ready.
          </p>
          <p>
            <b>Included in the service:</b>
          </p>
          <ul
            style={{
              listStyle: 'circle',
              marginLeft: '14px',
            }}
          >
            <li>Adjustment of gears, brakes, and tire pressure</li>
            <li>Tightening of bolts and nuts</li>
            <li>Cleaning and chain lubrication (no full wash)</li>
            <li>Service protocol</li>
          </ul>
          <p>
            Any replacement of worn parts will be done upon agreement and paid for separately
            on-site by card.
          </p>
          <p>
            <b>Location:</b> {props.event.location}
          </p>
          <p>
            <b>Place:</b> {props.event.place}
          </p>
        </div>
      )}
    </div>
  );
}

export default DynamicEventDetails;
